import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    if (req.url.indexOf("83/informes/controllers/informes_controller.php")){
      return next.handle(req)
    }
    const headers = new HttpHeaders({
      "Authorization": localStorage.getItem("token")
    });  
    const request = req.clone({
      headers
    });
    return next.handle(request);
  }

  constructor() { }
}
